module.exports = __webpack_public_path__ + "img/mt5_bg2.ada575b9.png";